import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiModal: Components<Theme>['MuiModal'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  // The page reserves its scrollbar gutter, so MUI's scroll-lock padding would shift the layout instead of steadying it.
  defaultProps: { disableScrollLock: true },
};

// ----------------------------------------------------------------------

export const modal = { MuiModal };
